import React from "react"
import FeatureItem from "./featureItem"
import { storyblokEditable } from "gatsby-source-storyblok"

const FeatureSection = ({blok}) => {

  return (
    <section className="my-20" {...storyblokEditable(blok)}>
      <div className="container flex flex-col justify-center p-4 mx-auto">
        <div className="grid grid-cols-1 gap-10 lg:grid-cols-3 xl:grid-cols-3">
          {blok.featureItems.map((blok, index) => (<FeatureItem blok={blok} key={index} />))}
        </div>
      </div>
    </section>
  )
}
  
export default FeatureSection
